import { render, staticRenderFns } from "./StaffMemberItem.vue?vue&type=template&id=6dba7976&scoped=true&"
import script from "./StaffMemberItem.vue?vue&type=script&lang=ts&"
export * from "./StaffMemberItem.vue?vue&type=script&lang=ts&"
import style0 from "./StaffMemberItem.vue?vue&type=style&index=0&id=6dba7976&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dba7976",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/brilliant/brilliant/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6dba7976', component.options)
    } else {
      api.reload('6dba7976', component.options)
    }
    module.hot.accept("./StaffMemberItem.vue?vue&type=template&id=6dba7976&scoped=true&", function () {
      api.rerender('6dba7976', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/views/about/components/StaffMemberItem.vue"
export default component.exports